import PropTypes from "prop-types"
import React from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/logo.svg"
import { useLogin, usePublicRoute } from "hooks/authHook"

const Login = () => {
  //meta title
  document.title = "Login | Aurobil Cars"
  const { isLoading: authLoading } = usePublicRoute()

  const loginMutation = useLogin()

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      emailOrUsername: "tanvir@ac.com" || "",
      password: "Hello@321" || "",
    },
    validationSchema: Yup.object({
      emailOrUsername: Yup.string()
        .test(
          "is-email-or-username",
          "Please enter a valid email or username",
          value => {
            // Basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            // Basic username validation (alphanumeric, underscores, hyphens)
            const usernameRegex = /^[a-zA-Z0-9_-]+$/

            return emailRegex.test(value) || usernameRegex.test(value)
          }
        )
        .required("Please enter your email or username"),
      password: Yup.string().required("Please enter your password"),
    }),
    onSubmit: async values => {
      try {
        await loginMutation.mutateAsync(values)
        // Redirect or show success message
      } catch (error) {
        // Handle error
      }
    },
  })

  if (authLoading) {
    return <div>Checking authentication...</div>
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue to Aurobil Cars.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email Or Username</Label>
                        <Input
                          name="emailOrUsername"
                          className="form-control"
                          placeholder="Enter Email Or Username"
                          type="emailOrUsername"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailOrUsername || ""}
                          invalid={
                            validation.touched.emailOrUsername &&
                            validation.errors.emailOrUsername
                              ? true
                              : false
                          }
                          disabled={loginMutation?.isPending}
                        />
                        {validation.touched.emailOrUsername &&
                        validation.errors.emailOrUsername ? (
                          <FormFeedback type="invalid">
                            {validation.errors.emailOrUsername}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                          disabled={loginMutation?.isPending}
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={
                            loginMutation?.isPending || !validation.isValid
                          }
                        >
                          {loginMutation.isPending ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" />
                              Logging in...
                            </>
                          ) : (
                            "Log In"
                          )}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link
                          to="/forgot-password"
                          className="text-muted"
                          style={{
                            pointerEvents: loginMutation.isPending
                              ? "none"
                              : "auto",
                            opacity: loginMutation.isPending ? 0.6 : 1,
                          }}
                        >
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Aurobil Cars. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by TelliCode
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
